import React from 'react';
import { Modal } from 'components';
import { CardPaymentMobile, CardPaymentZelle, cardPaymentExonerado } from 'assets/img';
import { Globals } from 'utils';

type ListItem = { id: number, name: string, icon?: string }

interface Props {
  visible: boolean
  onClose: (methodId?: number) => void
  paymentMethods: ListItem[]
  isMembership?: boolean
}

const PaymentMethodsModal = ({ visible, onClose, paymentMethods, isMembership = false }: Props) => {

  // 1. Filtramos "Exonerado" si NO es membresía
  const methodsToShow = isMembership
    ? paymentMethods
    : paymentMethods.filter(m => !m.name.toLowerCase().includes('exonerado'));

  // 2. Ordenamos para forzar que "Exonerado" siempre quede de último
  const sortedMethods = [...methodsToShow].sort((a, b) => {
    const isAExonerado = a.name.toLowerCase().includes('exonerado');
    const isBExonerado = b.name.toLowerCase().includes('exonerado');

    if (isAExonerado && !isBExonerado) return 1;  // Mueve 'a' al final
    if (!isAExonerado && isBExonerado) return -1; // Mueve 'b' al final
    return 0; // Mantiene el orden original para los demás
  });

  return (
    <Modal
      className="modal-payment-methods"
      withoutClose
      visible={visible}
      onClose={() => onClose()}
    >
      <div className="payment-card" style={{ padding: '30px 25px', backgroundColor: '#fff', borderRadius: '24px' }}>
        <p style={{ fontSize: '18px', fontFamily: 'Raleway-Bold', textAlign: 'center', marginBottom: '6px', color: '#1D1B20' }}>
          Método de pago
        </p>
        <p style={{ fontSize: '13px', fontFamily: 'Raleway-Medium', color: '#666', textAlign: 'center', marginBottom: '25px' }}>
          Seleccione método de pago
        </p>

        <div className="options">
          {/* 3. Mapeamos sobre el arreglo ya ordenado */}
          {sortedMethods.map(method => {
            const isZelle = method.name.toLowerCase().includes('zelle');
            const isPagoMovil = method.name.toLowerCase().includes('pago');
            const isExonerado = method.name.toLowerCase().includes('exonerado');

            return (
              <button
                key={method.id}
                className="method-card"
                onClick={() => onClose(method.id)}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  border: '1px solid #E1DED8',
                  borderRadius: '12px',
                  marginBottom: '12px',
                  backgroundColor: '#FFFFFF',
                  cursor: 'pointer',
                  padding: 0
                }}
              >
                <div style={isExonerado ? {
                  backgroundColor: '#4A72AA',
                  width: '100%',
                  height: '80px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderTopLeftRadius: '11px',
                  borderTopRightRadius: '11px',
                  borderBottom: '1px solid #E5E7EB',
                  overflow: 'hidden'
                } : { width: '100%' }}>

                  {isZelle ? (
                    <img src={CardPaymentZelle} alt="Zelle" style={{ width: '100%', display: 'block', borderTopLeftRadius: '11px', borderTopRightRadius: '11px' }} />
                  ) : isPagoMovil ? (
                    <img src={CardPaymentMobile} alt="Pago Movil" style={{ width: '100%', display: 'block', borderTopLeftRadius: '11px', borderTopRightRadius: '11px' }} />
                  ) : isExonerado ? (
                    <img style={{ height: '40px', objectFit: 'contain' }} src={cardPaymentExonerado} alt="Exonerado" />
                  ) : method.icon ? (
                    <img style={{ width: 20, height: 20, objectFit: 'contain', margin: '20px auto' }} src={Globals.fromPhotos('img/' + method.icon)} alt="icon" />
                  ) : (
                    <p style={{ color: '#555', fontFamily: 'Raleway-Bold', fontSize: 18, padding: '20px 0', margin: '0 auto' }}>{method.name.charAt(0)}</p>
                  )}

                </div>

                <div style={{ padding: '14px 16px', width: '100%', textAlign: 'center' }}>
                  <p className="method-text" style={{ margin: 0, fontSize: '15px', fontFamily: 'Raleway-Medium', color: '#1D1B20' }}>
                    {method.name}
                  </p>
                </div>
              </button>
            );
          })}
        </div>

        <div className="actions" style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
          <button
            className="alt"
            onClick={() => onClose()}
            style={{
              padding: '10px 30px',
              backgroundColor: '#FFFFFF',
              border: '1px solid #1D1B20',
              borderRadius: '8px',
              fontFamily: 'Raleway-Bold',
              fontSize: '14px',
              cursor: 'pointer'
            }}
          >
            CERRAR
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default PaymentMethodsModal;